import request from '@/utils/request'

// 获取所有单位列表
export function getAllCompany() {
  return request({
    url: '/recruitment-company/options',
    method: 'get'
  })
}

// 获取单位列表
export function getCompanyList(params) {
  return request({
    url: '/recruitment-company/list',
    method: 'get',
    params
  })
}

// 获取单位详情
export function getCompanyDetail(id) {
  return request({
    url: `/recruitment-company/${id}`,
    method: 'get'
  })
}

// 新增单位
export function createCompany(data) {
  return request({
    url: '/recruitment-company',
    method: 'post',
    data
  })
}

// 编辑单位
export function updateCompany(id, data) {
  return request({
    url: `/recruitment-company/${id}`,
    method: 'post',
    data
  })
}

// 删除单位
export function deleteCompany(id) {
  return request({
    url: `/recruitment-company/${id}`,
    method: 'delete'
  })
}

// 更新单位状态
export function updateCompanyStatus(id, status) {
  return request({
    url: `/recruitment-company/${id}/status`,
    method: 'post',
    data: { status }
  })
} 
export function getAllCompanyList(params) { 
  return request({
    url: '/recruitment-company/all',
    params,
    method: 'get'
  })
}

//重置密码
export function resetPassword(id) {
  return request({
    url: `/recruitment-company/reset-password/${id}`,
    method: 'post'
  })
}


// WEBPACK FOOTER //
// ./src/api/recruitment-company.js